import { render, staticRenderFns } from "./AccionEvento.vue?vue&type=template&id=7120fd80"
import script from "./AccionEvento.vue?vue&type=script&lang=js"
export * from "./AccionEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7120fd80')) {
      api.createRecord('7120fd80', component.options)
    } else {
      api.reload('7120fd80', component.options)
    }
    module.hot.accept("./AccionEvento.vue?vue&type=template&id=7120fd80", function () {
      api.rerender('7120fd80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/unidad-compuesta/AccionEvento.vue"
export default component.exports